<i18n>
  {
    "en": {
      "emptyData": "No data"
    },
    "ru": {
      "emptyData": "Нет данных"
    }
  }
</i18n>

<template>
  <div class="floor-plan" :style="{'height': `${height}px`}">
    <div v-if="!loadImage" :style="{'height': `${height - 18}px`}">
      <ImageTagger
        ref="imageTagger"
        :locationId="locationId"
        :hasEditPermissions="hasEditPermissions"
        :floorPlan="dataSource.floorPlan"
        :devices="devices"
        @update-device="changedPositionDevices"
        @reset-devices="resetDevices"
      />
    </div>

    <dx-load-panel :visible="loadImage" :position="{ of: '.floor-plan' }" />
  </div>
</template>

<script>
import baseView from "../base.vue";

import { DxLoadPanel } from "devextreme-vue/load-panel";

import ImageTagger from './image-tagger/image-tagger.vue';

import { getDictionaryItemDevices } from '@/services/api';
import { AclHandler } from "@/services/acl-handler";
import store from "../../store";

import { DataLocation } from "@/mixins/dataLocationMixin";

import axios from "axios";

export default {
  name: 'LocationFloorPlan',
  props: {
    locationId: {
      type: Number,
      required: true
    },
    dataSource: {
      type: Object,
      required: true
    },
    locationsItems: {
      type: Array,
      required: false
    },
    agentsItems: {
      type: Array,
      required: false
    },
    locationDictionaryChild: {
      type: Array,
      required: false
    },
    statisticsDevices: {
      type: Object,
      required: false
    }
  },
  extends: baseView,
  mixins: [DataLocation],
  components: {
    DxLoadPanel, ImageTagger
  },
  data() {
    return {
      isCloudMode: this.$store.getters.isCloudMode,
      devices: [],
      loadImage: true,
    };
  },
  computed: {
    appUser() {
      return this.$store.getters.user;
    },
    aclUser() {
      return new AclHandler(this.appUser, this.isCloudMode);
    },
    hasEditPermissions() {
      return this.aclUser.hasGrantForOperation('PAGE_LOCATION', 'EDIT') || false;
    },
    width() {
      return (this.$store.getters.layoutBody.width - 4 * 40 - 2 * 20 - 46) || 400;
    },
    height() {
      return (this.$store.getters.layoutBody.height - 20 - 2 * 40 - 2 * 20 - 37 - 57) || 400;
    },
    isNew() {
      return this.locationId < 0;
    },
  },
  methods: {
    changedPositionDevices(updated) {
      this.dataSource.floorPlan.updateDevicesCoordinates = true;

      const idx = this.devices.findIndex(d => d.id === updated.id);
      if (idx === -1) return;

      this.$set(this.devices, idx, {
        ...this.devices[idx],
        ...updated
      });

      this.$emit('update-device', this.devices);
    },
    resetDevices() {
      this.dataSource.floorPlan.updateDevicesCoordinates = true;
      this.dataSource.floorPlan.fileUploaded = null;
      this.dataSource.floorPlan.imageFloorUrl = null;

      const devices = this.devices.map(d => ({
          ...d,
          xcoordinate: null,
          ycoordinate: null
      }));

      this.devices = devices;

      this.$emit('update-device', devices);
    },
    async loadData() {
      if (!this.isNew) {
        const devices = await getDictionaryItemDevices(this.locationId);
        this.devices = devices
      }

      this.dataSource.floorPlan.imageFloorUrl = null;

      if (this.dataSource.floorPlan.attr && this.dataSource.floorPlan.attr.id) {
        const API_URL = store.getters.apiPath;
        axios({
          method: 'get',
          url: `${API_URL}/dictionary-items/${this.locationId}/attributes/location/${this.dataSource.floorPlan.attr.id}` ,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            "Authorization": store.getters.token // must add request head
          },
          responseType: "arraybuffer", //  Key setting response type is binary stream
        })
        .then((response) => {// will flow the picture of the background in the backstage Huawei Base64
          return 'data:image/jpeg;base64,' + btoa(
            new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
          );
        })
        .then(data=>{
          this.dataSource.floorPlan.imageFloorUrl = data; //  Data is the image address
          this.loadImage = false;
        })
        .catch((err)  => {
          this.loadImage = false;
          const errorMessage = new TextDecoder().decode(new Uint8Array(err.response.data));

          this.onDataError({message: errorMessage});
        });
      } else {
        this.loadImage = false;
      }
    },
  },
  created() {
    this.loadData();
  },
  watch: {
    locationId() {
      this.loadImage = true;
      this.devices = [];
    }
  }
};
</script>

<style lang="scss">
.floor-plan {
  display: flex;
  flex-direction: column;
  box-sizing: content-box;
}
</style>